import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { isEmpty } from 'bold-ui'

import { ConsultaSeguimentoPergunta15Model } from './model-consultaSeguimentoPergunta15'
import {
  hasPergunta15TentaImitarAtLeastTwoSim,
  isPergunta15TentaImitarAllFilled,
} from './utils-consultaSeguimentoPergunta15'

export const PERGUNTA_15_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta15Model> = {
  PERGUNTA_15_HEADER: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: 'PERGUNTA_15_TENTA_IMITAR',
      },
    ],
  },
  PERGUNTA_15_TENTA_IMITAR: {
    scrollConditions: [
      {
        if: (_, allValues) => hasPergunta15TentaImitarAtLeastTwoSim(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (_, allValues) =>
          isPergunta15TentaImitarAllFilled(allValues) && !hasPergunta15TentaImitarAtLeastTwoSim(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_15_HEADER',
  },
}
